import React from 'react';
import {
  FeatureType,
  type Feature as FeatureProps,
} from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';
import Feature from '../Feature';
import { Column } from '../styled.ts';

const renderFeature = (feature: FeatureProps, index: number) => (
  <Feature key={`${feature.icon}${feature.featureType}${index}`} testId={feature.className} {...feature} />
);

const isRealRow = ({ featureType, text }: FeatureProps) => featureType !== FeatureType.waiting && !!text;

// role=list because Safari drops list semantics once list-style is none
export const getListProps = (features: FeatureProps[]) =>
  features.some(isRealRow) ? ({ as: 'ul', role: 'list' } as const) : {};

const FeaturesIterator = ({
  features,
  useColumnLayout = false,
}: {
  features: FeatureProps[];
  useColumnLayout?: boolean;
}) => {
  if (useColumnLayout) {
    const left = features.filter((f) => f.gridSide !== 'right');
    const right = features.filter((f) => f.gridSide === 'right');

    return (
      <>
        <Column {...getListProps(left)}>{left.map(renderFeature)}</Column>
        {right.length > 0 && <Column {...getListProps(right)}>{right.map(renderFeature)}</Column>}
      </>
    );
  }

  return <>{features.map(renderFeature)}</>;
};

export default FeaturesIterator;
